import MyTable from '../../../../../components/MyTable';
import FilterPopup from '../../../../../components/FilterPopup';

const CandidateInterviewsTable = ({
  data,
  columns,
  options,
  isFilterPopupOpen,
  onFilterClick,
  onCloseFilterPopup,
  onApplyFilters,
  getSearchResults,
  filterCategories,
}) => (
  <div className="w-full overflow-x">
    <MyTable
      title=""
      data={data}
      columns={columns}
      options={options}
      onFilterClick={onFilterClick}
    />
    {isFilterPopupOpen && (
      <FilterPopup
        onClose={onCloseFilterPopup}
        onApply={onApplyFilters}
        tableData={data}
        categories={filterCategories}
        getSearchResults={getSearchResults}
      />
    )}
  </div>
);

export default CandidateInterviewsTable;
